module.exports = __webpack_public_path__ + "static/goku-96b521777bf5ba88caf45ea50ce7fc87.gif";